import { useState } from 'react';

const GoogleReviewPhotosSection = () => {
  const [isLoading, setIsLoading] = useState(true);

  // 建鈞精緻搬家 Google 商家資訊
  const googleBusinessInfo = {
    name: '建鈞精緻搬家',
    rating: 5.0,
    totalReviews: 71,
    // 建鈞精緻搬家的 Google 地圖商家連結 - 使用最簡單的搜尋格式
    googleMapsUrl: 'https://www.google.com/maps/search/建鈞精緻搬家+新北市泰山區福德街49號3樓'
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區域 */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-100 to-emerald-100 border border-teal-300 rounded-full px-5 py-2 shadow-sm mb-6">
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span className="text-sm font-bold text-teal-700">Google 官方評論</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>Google 地圖真實評論</strong>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            點擊下方按鈕前往 <strong className="text-teal-600">Google 地圖</strong> 查看所有客戶真實評論與照片
          </p>
        </div>

        {/* Google 評論卡片 */}
        <div className="bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-xl p-8 md:p-12 mb-12 border border-gray-100">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            {/* 左側：商家資訊 */}
            <div className="flex items-center gap-6">
              {/* Google Logo */}
              <div className="bg-white rounded-2xl p-5 shadow-lg border border-gray-100">
                <svg className="w-16 h-16" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
              </div>
              
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                  {googleBusinessInfo.name}
                </h3>
                <div className="flex flex-wrap items-center gap-4">
                  <div className="flex items-center gap-2">
                    <span className="text-4xl font-bold text-gray-900">{googleBusinessInfo.rating}</span>
                    <div className="flex gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                      ))}
                    </div>
                  </div>
                  <div className="h-8 w-px bg-gray-300 hidden sm:block"></div>
                  <div className="flex items-center gap-2">
                    <i className="ri-chat-3-line text-teal-600 text-xl"></i>
                    <span className="text-lg text-gray-600 font-medium">{googleBusinessInfo.totalReviews}+ 則評論</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 右側：CTA 按鈕 */}
            <div className="flex flex-col gap-4">
              <a
                href={googleBusinessInfo.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-teal-600 to-emerald-600 text-white px-8 py-4 rounded-full font-semibold hover:from-teal-700 hover:to-emerald-700 transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span>查看 Google 評論與照片</span>
                <i className="ri-external-link-line text-xl"></i>
              </a>
              <p className="text-sm text-gray-500 text-center">
                <i className="ri-shield-check-line text-teal-600 mr-1"></i>
                前往 Google 地圖查看真實評論
              </p>
            </div>
          </div>
        </div>

        {/* Google Maps 嵌入 */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden mb-12 border border-gray-100">
          <div className="bg-gradient-to-r from-gray-50 to-white px-6 py-4 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100">
                  <svg className="w-5 h-5" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </div>
                <span className="font-semibold text-gray-700">Google 地圖 - 建鈞精緻搬家</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <i className="ri-verified-badge-line text-blue-500"></i>
                <span>官方認證商家</span>
              </div>
            </div>
          </div>

          <div className="relative">
            {isLoading && (
              <div className="absolute inset-0 bg-gray-50 flex items-center justify-center z-10">
                <div className="text-center">
                  <div className="w-12 h-12 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                  <p className="text-gray-600">載入 Google 地圖中...</p>
                </div>
              </div>
            )}
            <iframe
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=place_id:ChIJ-323pM-rQjQR9vXlY_yY_sU&zoom=15"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full"
              onLoad={() => setIsLoading(false)}
              title="建鈞精緻搬家 Google 地圖位置"
            />
          </div>
        </div>

        {/* 評論特色說明 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center border border-teal-100">
            <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-star-fill text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">5.0 滿分評價</h4>
            <p className="text-gray-600 text-sm">所有客戶都給予五星好評，品質有保證</p>
          </div>

          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 text-center border border-emerald-100">
            <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-image-line text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">真實照片分享</h4>
            <p className="text-gray-600 text-sm">客戶在 Google 地圖分享的真實搬家照片</p>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 text-center border border-teal-100">
            <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-verified-badge-fill text-white text-2xl"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">100% 可查證</h4>
            <p className="text-gray-600 text-sm">所有評論都可在 Google 地圖上查證</p>
          </div>
        </div>

        {/* 底部 CTA */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl p-8 border border-teal-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">想看更多真實客戶評論？</h3>
            <p className="text-gray-600 mb-6">前往 Google 地圖查看所有 71+ 則五星好評與客戶分享的照片</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={googleBusinessInfo.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white border-2 border-gray-200 text-gray-700 px-6 py-3 rounded-full font-semibold hover:border-teal-500 hover:text-teal-600 transition-all cursor-pointer whitespace-nowrap shadow-sm hover:shadow-md"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                查看 Google 地圖評論
                <i className="ri-external-link-line"></i>
              </a>
              <a
                href="https://line.me/ti/p/@285yavdh"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#06C755] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#05b34c] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
              >
                <i className="ri-line-fill text-xl"></i>
                立即 LINE 免費諮詢
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviewPhotosSection;